/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Share My World AB.
 * 
 * @copyright Share My World AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE_SDK.md file.
 * 
 * 
 * @version 0.16.3
 */
(function (r, f) { if (typeof define === 'function' && define.amd) { define(['./colibrio-core-base', './colibrio-core-io-base'], function (a0, a1) { return f(a0, a1); }); } else if (typeof module === 'object' && module.exports) { module.exports = f(require('./colibrio-core-base'), require('./colibrio-core-io-base')); } else { r.colibrio = r.colibrio || {}; r.colibrio.core = r.colibrio.core || {}; r.colibrio.core.publication = r.colibrio.core.publication || {}; r.colibrio.core.publication.base = f(colibrio.core.base, colibrio.core.io.base); } }(typeof self !== 'undefined' ? self : this, function(__dep__colibrio_core_base, __dep__colibrio_core_io_base) { var api = {}; (function() { api={}; })(); return api; }));
